import { useContext } from 'react'
import context from './context'
import defaultTheme from './themes/_default'

export default () => {
  const data = useContext(context)
  const { theme, themeClass } = data || {}

  const { colors, fontWeights, fontSizes, boxShadow } = theme || defaultTheme

  return {
    colors,
    fontWeights,
    fontSizes,
    themeClass,
    boxShadow,
  }
}
